/* eslint-disable import/no-cycle */
import * as types from './types';
import accountApi from '@/modules/account/api/accountApi';
import reportingApi from '@/modules/reporting/api/reportingApi';
import campaignApi from '@/modules/campaigns/api/campaignApi';

const actions = {
  [types.FETCH_PUBLISHER_IDS_WITH_STATS]: (context, payload) => reportingApi
    .getPublisherIdsWithStats(payload)
    .then((publisherIds) => publisherIds)
    .catch((error) => error),
  [types.FETCH_CAMPAIGN_CONTENT_DAILY_STATS]: (context, payload) => reportingApi
    .getContentDailyStats(payload)
    .then((publisherDailyStats) => publisherDailyStats)
    .catch((error) => error),
  [types.FETCH_OVERALL_CREATIVE_CAMPAIGN_STATS]: (context, payload) => reportingApi
    .getOverallCreativeCampaignStats(payload)
    .then((stats) => stats)
    .catch((error) => error),
  [types.FETCH_REPORTS_ADVERTISERS]: (context, payload) => accountApi.fetchReportAdvertisers(payload)
    .then((response) => response)
    .catch((error) => {
      throw error;
    }),
  [types.FETCH_REPORTS_SHARED_ADVERTISERS]: (context, payload) => accountApi.fetchReportSharedAdvertisers(payload)
    .then((response) => response)
    .catch((error) => {
      throw error;
    }),
  [types.FETCH_REPORTS_SHARED_CAMPAIGNS]: (context, payload) => campaignApi.getSharedCampaignsForReports(payload)
    .then((response) => response.campaigns)
    .catch((error) => {
      throw error;
    }),
  [types.FETCH_REPORTS_SELF_SERVICE_CAMPAIGNS]: (context, { params = {}, filters = {}, managed = false }) => {
    const {
      page, perPage, sortBy, sortDesc,
    } = params;
    const {
      search, states, advertiserId, accountManagerId,
    } = filters;
    const orderDirection = (sortDesc) ? 'DESC' : 'ASC';

    const queryParams = '?'.concat(
      page ? `&page=${page}&pageSize=${perPage}` : '',
      sortBy ? `&sortBy=${sortBy}&sortDirection=${orderDirection}` : '',
      '&type=SELF_SERVICE',
      search ? `&search=${encodeURIComponent(search)}` : '',
      states ? `&campaignStates=${states}` : '',
      advertiserId ? `&aid=${advertiserId}` : '',
      accountManagerId ? `&accountManagerId=${accountManagerId}` : '',
    );

    return campaignApi
      .getSelfServiceCampaigns(queryParams, managed)
      .then((response) => response.campaigns)
      .catch((error) => {
        throw error;
      });
  },
  [types.DOWNLOAD_REPORT_CSV]: (context, payload) => reportingApi.downloadReportAsCSV(payload)
    .then((response) => response)
    .catch((error) => {
      throw error;
    }),
  [types.SET_SELECTED_FILTER]: (context, payload) => {
    context.commit(types.SET_SELECTED_FILTER, payload);
  },
  [types.SET_SELECTED_ADVERTISER_DETAILS]: (context, payload) => {
    context.commit(types.SET_SELECTED_ADVERTISER_DETAILS, payload);
  },
  [types.RESET_STORE]: (context) => {
    context.commit(types.RESET_STORE);
  },
};
export default actions;
